import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* About */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-base"></i>
              </span>
              <span className="font-heading font-bold text-base">{t("brand")}</span>
            </div>
            <p className="text-sm text-background-100/80 leading-relaxed">{t("footer.aboutDesc")}</p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              {t("footer.exploreTitle")}
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <a href="/#spreadsheet" className="text-sm text-background-100/80 hover:text-background-50 transition-colors">
                  {t("nav.spreadsheet")}
                </a>
              </li>
              <li>
                <a href="/#categories" className="text-sm text-background-100/80 hover:text-background-50 transition-colors">
                  {t("nav.categories")}
                </a>
              </li>
              <li>
                <Link to="/allchinabuy-spreadsheet-guide" className="text-sm text-background-100/80 hover:text-background-50 transition-colors">
                  {t("articleEntry.cardTitle")}
                </Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-100/80 hover:text-background-50 transition-colors">
                  {t("hero.ctaSecondary")}
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">{t("nav.categories")}</h4>
            <ul className="flex flex-wrap gap-x-4 gap-y-2">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-100/80 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {t(`categories.${cat.id}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-background-100/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-100/70">{t("footer.disclaimer")}</p>
          <p className="text-xs text-background-100/70 whitespace-nowrap">
            © {year} {t("brand")}. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}